<ng-template #emojiTemplate let-symbol="symbol" [ngTemplateType]="EmojiTemplateType">
  <span title="{{ symbol.title }}">
    <rt-emoji [emoji]="symbol.value.symbol" [size]="24" />
  </span>
</ng-template>

<ng-template #iconTemplate let-symbol="symbol" [ngTemplateType]="IconTemplateType">
  <rt-icon-font [name]="symbol.value" title="{{ symbol.title }}" />
</ng-template>

<rt-dropdown [width]="DropdownWidth.LargeX">
  @if (dataSources.length > 1 || hasClearButton) {
    <div class="header">
      @if (dataSources.length > 1) {
        <rt-tabs [hasBottomSeparator]="false">
          @for (dataSource of dataSources; track dataSource.id) {
            <rt-tab
              (click)="onDataSourceChange(dataSource)"
              [class.active]="currentDataSource.id === dataSource.id"
            >
              {{ dataSource.label }}
            </rt-tab>
          }
        </rt-tabs>
      }
      @if (hasClearButton) {
        <rt-button class="clear" variant="plain" (click)="clear.emit()">
          {{ translations.clear }}
        </rt-button>
      }
    </div>
  }

  @if (withSearchInput()) {
    <rt-form-field padding-small-x>
      <rt-input
        [autoFocus]="true"
        [formControl]="searchFormControl"
        [placeholder]="translations.searchPlaceholder"
        variant="rounded"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
  }
  <div
    #virtualScrollerComponent
    [bufferAmount]="10"
    [enableUnequalChildrenSizes]="true"
    [executeRefreshOutsideAngularZone]="true"
    [items]="virtualScrollRows"
    [style.height.px]="withSearchInput() ? 244 : 288"
    [scrollDebounceTime]="10"
    (vsChange)="onChange($event)"
    (vsUpdate)="listUpdate($event)"
    [style.overflow-y]="isScrollAlwaysVisible ? 'scroll' : 'auto'"
    class="symbols-container"
    virtualScroller
  >
    @for (row of virtualScrollData; track row; let indexRow = $index) {
      <div [class.symbol-row]="SymbolVirtualScrollItem.SymbolRow === row.type">
        @if (SymbolVirtualScrollItem.Heading === row.type) {
          <rt-dropdown-header [isSubheading]="true">
            {{ translations.categories[row.name] }}
          </rt-dropdown-header>
        }

        @if (SymbolVirtualScrollItem.SymbolRow === row.type) {
          @for (symbol of row.data; track symbol.title; let indexCol = $index) {
            <span
              (click)="onSelect(symbol.value)"
              (mouseenter)="onMouseEnter(indexRow + startIndexWithBuffer, indexCol)"
              [ngClass]="[currentDataSource.id + '-item']"
              [class.active]="
                indexRow + startIndexWithBuffer === activeRow && indexCol === activeCol
              "
            >
              <ng-template
                [ngTemplateOutlet]="templateIdMap[currentDataSource.id]"
                [ngTemplateOutletContext]="{ symbol }"
              />
            </span>
          }
        }
      </div>
    }
  </div>
</rt-dropdown>
